export default __webpack_public_path__ + "static/media/men-tree.b5070521.svg";